// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__3DM4X","insted-nav":"Navbar_insted-nav__3U61h","item":"Navbar_item__299FJ"};